import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { StyledButton, StyledModalButtonsContainer } from './modal-buttons.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Modal Buttons component.
 *
 * @author Mikhail Siutsou
 * @function ModalButtons
 * @category components
 * @param {ModalButtonsProps} content props.
 * @return {JSX.Element} Modal Buttons component.
 */
var ModalButtons = function ModalButtons(_ref) {
  var rejectButton = _ref.rejectButton,
      acceptButton = _ref.acceptButton,
      acceptModal = _ref.acceptModal,
      rejectModal = _ref.rejectModal;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(StyledModalButtonsContainer, {
    children: /*#__PURE__*/_jsxs(Grid, {
      container: true,
      spacing: 2,
      justifyContent: "flex-end",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        sm: "auto",
        order: {
          xs: 2,
          sm: 1
        },
        children: /*#__PURE__*/_jsx(StyledButton, {
          color: "inherit",
          fullWidth: true,
          onClick: rejectModal,
          children: rejectButton || t('modals.buttons.cancel')
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        sm: "auto",
        order: {
          xs: 1,
          sm: 2
        },
        children: /*#__PURE__*/_jsx(StyledButton, {
          color: "primary",
          variant: "contained",
          fullWidth: true,
          onClick: acceptModal,
          children: acceptButton || t('modals.buttons.save')
        })
      })]
    })
  });
};

ModalButtons.displayName = 'ModalButtons';
export { ModalButtons };